import React, { useState } from "react";
import Row from "@amzn/meridian/row";
import Column from "@amzn/meridian/column";
import Modal from "@amzn/meridian/modal";
import Button from "@amzn/meridian/button";
import Icon from "@amzn/meridian/icon";
import plusKnockoutTokens from "@amzn/meridian-tokens/base/icon/plus-knockout";
import RadioButton from "@amzn/meridian/radio-button";
import UpsertRoleRatioRule from "./UpsertRoleRatioRule";
import UpsertVolumeRatioRule from "./UpsertVolumeRatioRule";

import UpsertMinHeadcountRule from "./UpsertMinHeadcountRule";
import UpsertRateRule from "./UpsertRateRule";
import { SSD_RULE } from "../SettingsConstant";

const FIXED = "Fixed HC";
const DEMAND = "Demand role";
const ROLE_RATIO = "Role ratio rule";
const VOLUME_RATIO = "Volume ratio rule";

const DEFAULT_MIN_HC_RULE = {
  ...SSD_RULE.MIN_HEADCOUNT,
  value: [{ value: 0, start: "00:00", end: "23:59" }],
};

const DEFAULT_ROLE_RATIO_RULE = {
  ...SSD_RULE.ROLE_RATIO,
  value: [
    {
      value: 0,
      role_headcount: 0,
      reference_role_headcount: 0,
      start: "00:00",
      end: "23:59",
      percentage_of_process_role: null,
      percentage_of_process_path: null,
      percentage_of_process: null,
    },
  ],
};

const DEFAULT_VOLUME_RATIO_RULE = {
  ...SSD_RULE.VOLUME_RATIO,
  value: [
    {
      value: 0,
      per_no_of_packages: 0,
      start: "00:00",
      end: "23:59",
      percentage_of_process_role: null,
      percentage_of_process_path: null,
      percentage_of_process: null,
    },
  ],
};

const CreateRuleModel = ({ rules, onSubmit }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedRuleOption, setSelectedRuleOption] = useState(FIXED);
  const minHcRule = { ...DEFAULT_MIN_HC_RULE };
  const rateBasedRule = { ...SSD_RULE.RATE_BASED };
  const roleRatioRule = { ...DEFAULT_ROLE_RATIO_RULE };
  const volumeRatioRule = { ...DEFAULT_VOLUME_RATIO_RULE };
  return (
    <Column>
      <Row alignmentHorizontal="end" widths="fit">
        <Button onClick={() => setIsOpen(true)} type="tertiary">
          <Icon tokens={plusKnockoutTokens} />
          Add Requirement
        </Button>
      </Row>
      <Modal
        title="New Rule"
        open={isOpen}
        onClose={() => setIsOpen(false)}
        closeLabel="Close"
      >
        <Row alignmentHorizontal="center">
          <RadioButton
            checked={selectedRuleOption === FIXED}
            onChange={setSelectedRuleOption}
            value={FIXED}
            size="medium"
          >
            {FIXED}
          </RadioButton>
          <RadioButton
            checked={selectedRuleOption === DEMAND}
            onChange={setSelectedRuleOption}
            value={DEMAND}
            size="medium"
          >
            {DEMAND}
          </RadioButton>
          <RadioButton
            checked={selectedRuleOption === ROLE_RATIO}
            onChange={setSelectedRuleOption}
            value={ROLE_RATIO}
            size="medium"
          >
            {ROLE_RATIO}
          </RadioButton>
          <RadioButton
            checked={selectedRuleOption === VOLUME_RATIO}
            onChange={setSelectedRuleOption}
            value={VOLUME_RATIO}
            size="medium"
          >
            {VOLUME_RATIO}
          </RadioButton>
        </Row>
        <Row height={25} />
        {selectedRuleOption === FIXED && (
          <UpsertMinHeadcountRule
            rules={rules}
            rule={minHcRule}
            onSubmit={onSubmit}
            onCancel={() => setIsOpen(false)}
            isEditRule={false}
          />
        )}
        {selectedRuleOption === DEMAND && (
          <UpsertRateRule
            rules={rules}
            rule={rateBasedRule}
            onSubmit={onSubmit}
            onCancel={() => setIsOpen(false)}
            isEditRule={false}
          />
        )}
        {selectedRuleOption === ROLE_RATIO && (
          <UpsertRoleRatioRule
            rules={rules}
            rule={roleRatioRule}
            onSubmit={onSubmit}
            onCancel={() => setIsOpen(false)}
            isEditRule={false}
          />
        )}
        {selectedRuleOption === VOLUME_RATIO && (
          <UpsertVolumeRatioRule
            rules={rules}
            rule={volumeRatioRule}
            onSubmit={onSubmit}
            onCancel={() => setIsOpen(false)}
            isEditRule={false}
          />
        )}
      </Modal>
    </Column>
  );
};
export default CreateRuleModel;



// WEBPACK FOOTER //
// ./src/components/settings/settingsv2/ssd/CreateRuleModal.js